/* Gudslip — Kazı Kazan popup
 * Akış: gecikme → popup → kartı kazı → e-posta formu (Shopify müşteri formu) → sayfa geri döner → başarı ekranı
 * Hafıza: localStorage  gk:<kampanya>:snooze | :pending | :done
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gk]');
  if (!root) return;

  var ds = root.dataset;
  var campaign = ds.campaign || 'kazi-kazan';
  var KEY = 'gk:' + campaign;
  var delay = parseInt(ds.delay, 10); if (isNaN(delay)) delay = 9;
  var snoozeDays = parseInt(ds.snoozeDays, 10) || 3;
  var threshold = (parseInt(ds.threshold, 10) || 45) / 100;
  var designMode = ds.designMode === 'true';
  var PENDING_TTL = 45 * 60 * 1000; // 45 dk

  var canvas = q('[data-gk-canvas]');
  var card = q('[data-gk-card]');
  var form = q('[data-gk-form]');
  var steps = {
    scratch: q('[data-gk-step="scratch"]'),
    form: q('[data-gk-step="form"]'),
    success: q('[data-gk-step="success"]')
  };

  var opened = false;
  var canvasReady = false;
  var timer = null;

  function q(sel) { return root.querySelector(sel); }
  function now() { return Date.now(); }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }

  function showStep(name) {
    Object.keys(steps).forEach(function (k) { if (steps[k]) steps[k].hidden = (k !== name); });
  }

  function open(step) {
    if (opened) return;
    opened = true;
    step = step || 'scratch';
    root.hidden = false;
    root.classList.add('is-open');
    document.documentElement.classList.add('gk-lock');
    showStep(step);
    if (step === 'scratch') requestAnimationFrame(function () { setTimeout(initCanvas, 60); });
    var closeBtn = q('.gk__close');
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
    document.addEventListener('keydown', onKey);
    root.dispatchEvent(new CustomEvent('gk:open', { bubbles: true, detail: { step: step } }));
  }

  function close(soft) {
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.classList.remove('gk-lock');
    document.removeEventListener('keydown', onKey);
    opened = false;
    if (!designMode && !soft) store(KEY + ':snooze', String(now() + snoozeDays * 864e5));
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  /* ---------- kazıma alanı ---------- */
  function hexToRgb(hex) {
    hex = (hex || '').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(hex, 16);
    if (isNaN(n)) return { r: 232, g: 218, b: 182 };
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }
  function shade(hex, amt) {
    var c = hexToRgb(hex);
    function cl(v) { return Math.max(0, Math.min(255, Math.round(v + amt))); }
    return 'rgb(' + cl(c.r) + ',' + cl(c.g) + ',' + cl(c.b) + ')';
  }

  function initCanvas() {
    if (canvasReady || !canvas || !card) return;
    var rect = card.getBoundingClientRect();
    if (rect.width < 10) { setTimeout(initCanvas, 120); return; }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = rect.width, H = rect.height;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';

    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.scale(dpr, dpr);

    // folyo
    var foil = ds.foil || '#E8DAB6';
    var g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, shade(foil, 22));
    g.addColorStop(0.5, foil);
    g.addColorStop(1, shade(foil, -18));
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);

    // ince parlama çizgileri
    ctx.save();
    ctx.globalAlpha = 0.10;
    ctx.fillStyle = '#ffffff';
    ctx.translate(W / 2, H / 2);
    ctx.rotate(-0.45);
    for (var x = -W; x < W; x += 26) ctx.fillRect(x, -H, 7, H * 2);
    ctx.restore();

    // yazı
    ctx.fillStyle = ds.foilText || '#1B2A6B';
    ctx.font = '600 ' + Math.max(18, Math.round(W * 0.085)) + 'px Delight, Inter, "Helvetica Neue", Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(ds.scratchLabel || 'BURAYI KAZI', W / 2, H / 2);

    // kazıma modu
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(38, W * 0.13);
    canvasReady = true;

    var drawing = false, last = null, moves = 0, done = false;

    function pos(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function scratch(p) {
      ctx.beginPath();
      ctx.moveTo(last ? last.x : p.x, last ? last.y : p.y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      // tek dokunuşta da iz bıraksın
      ctx.beginPath();
      ctx.arc(p.x, p.y, ctx.lineWidth / 2, 0, Math.PI * 2);
      ctx.fill();
      last = p;
    }
    function ratio() {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var step = 4 * 10, clear = 0, total = 0;
      for (var i = 3; i < data.length; i += step) { total++; if (data[i] === 0) clear++; }
      return total ? clear / total : 0;
    }
    function reveal() {
      if (done) return;
      done = true;
      canvas.classList.add('is-revealed');
      card.classList.add('is-revealed');
      root.classList.add('is-scratched');
      setTimeout(function () {
        showStep('form');
        var em = q('.gk__email');
        if (em && window.matchMedia('(min-width: 768px)').matches) { try { em.focus({ preventScroll: true }); } catch (e) {} }
      }, 900);
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (done) return;
      drawing = true; last = null;
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      scratch(pos(e));
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drawing || done) return;
      scratch(pos(e));
      if (++moves % 6 === 0 && ratio() >= threshold) reveal();
      e.preventDefault();
    });
    function stop() {
      if (!drawing) return;
      drawing = false; last = null;
      if (!done && ratio() >= threshold) reveal();
    }
    canvas.addEventListener('pointerup', stop);
    canvas.addEventListener('pointercancel', stop);
    canvas.addEventListener('lostpointercapture', stop);
  }

  /* ---------- form ---------- */
  if (form) {
    var ret = form.querySelector('[data-gk-return]');
    if (ret) ret.value = location.pathname + '?gk=ok';

    form.addEventListener('submit', function (e) {
      var consent = form.querySelector('[data-gk-consent]');
      var consentErr = form.querySelector('[data-gk-consent-error]');
      var email = form.querySelector('.gk__email');
      var emailOk = !!(email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value || ''));
      var consentOk = !consent || consent.checked;
      if (email) email.setAttribute('aria-invalid', emailOk ? 'false' : 'true');
      form.classList.toggle('is-invalid', !consentOk);
      if (consentErr) consentErr.hidden = consentOk;
      if (!emailOk) { e.preventDefault(); try { email.focus(); } catch (err) {} return; }
      if (!consentOk) { e.preventDefault(); try { consent.focus(); } catch (err) {} return; }
      store(KEY + ':pending', String(now()));
      var btn = form.querySelector('.gk__cta');
      if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    });
  }

  /* ---------- kapatma ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-gk-close]'), function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); close(); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-gk-close-soft]'), function (el) {
    el.addEventListener('click', function () { close(true); });
  });

  /* ---------- karar ---------- */
  var pendingAt = parseInt(read(KEY + ':pending'), 10);
  var pending = pendingAt && (now() - pendingAt) < PENDING_TTL;
  var posted = /[?&](gk=ok|customer_posted=true)/.test(location.search) || !!q('[data-gk-posted]');
  var hasErr = !!q('[data-gk-error]');

  if (posted && pending) {
    store(KEY + ':pending', null);
    store(KEY + ':done', String(now()));
    store(KEY + ':snooze', String(now() + 365 * 864e5));
    open('success');
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    return;
  }

  if (hasErr && pending) {
    store(KEY + ':pending', null);
    open('form');
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    return;
  }

  // #kazi-kazan bağlantısı ile her zaman açılabilsin (ör. footer'a link konursa)
  function bindHashOpen() {
    if (location.hash === '#kazi-kazan') { opened = false; open('scratch'); }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#kazi-kazan"]');
      if (a) { e.preventDefault(); opened = false; open('scratch'); }
    });
  }

  if (designMode) {
    // tema düzenleyicide hemen göster; kapatınca hatırlama yapma
    open('scratch');
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target && e.target.contains(root)) { opened = false; open('scratch'); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && e.target.contains(root)) close(true);
    });
    return;
  }

  bindHashOpen();

  if (ds.enabled !== 'true') return;
  if (read(KEY + ':done')) return;
  var snooze = parseInt(read(KEY + ':snooze'), 10);
  if (snooze && now() < snooze) return;

  timer = setTimeout(function () { open('scratch'); }, delay * 1000);
})();
